import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=06127a1c&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"
import style0 from "./QrCode.vue?vue&type=style&index=0&id=06127a1c&prod&lang=css"
import style1 from "./QrCode.vue?vue&type=style&index=1&id=06127a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06127a1c",
  null
  
)

export default component.exports